// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2zu_1","footer":"ModalError_footer__244he"};